import {
  SET_SUPPLIER_ASSESSMENT_DETAILS,
  SET_SUPPLIER_STAKEHOLDERS_LIST,
  SET_SUPPLIER_SURVEY_DOCUMENTS,
} from "constants/supplierAssessment/supplierAssessmentConst";
import apiBolerplate from "utils/_helpers/apiBolerplate";
import { getSupplierAdminStakeholders } from "../supplierAdmin/supplierAdminActions";

// ----------------- Payloads -----------------
export function setMaterialityAssessmentList(payload) {
  return {
    type: SET_SUPPLIER_ASSESSMENT_DETAILS,
    payload: payload,
  };
}
export function setSupplierStakeholdersList(payload) {
  return {
    type: SET_SUPPLIER_STAKEHOLDERS_LIST,
    payload: payload,
  };
}

export function setSupplierSurveyDocuments(payload) {
  return {
    type: SET_SUPPLIER_SURVEY_DOCUMENTS,
    payload: payload,
  };
}

// ----------------- Actions -----------------

export async function getSupplierAssessmentDetails(supplier_id) {
  const data = await apiBolerplate({
    url: "/supplier/get_supplier_details",
    bodyData: { supplier_id },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export function updateSupplierAssessmentDetails(
  details,
  logo,
  fetchSupplierAssessmentDetails
) {
  return async () => {
    await apiBolerplate({
      url: "/supplier/update_supplier",
      bodyData: { ...details },
      files: { file: logo },
      hideLoader: true,
      hideMsg: false,
      messageType: "success",
      callback: (data) => {
        fetchSupplierAssessmentDetails(details?.supplier_id);
      },
    });
  };
}

export function getSupplierStakeholders(parent_id) {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/supplier/get_supplier_admins",
      bodyData: { supplier_id: parent_id },
      hideLoader: true,
      hideMsg: true,
      callback: (data) => {
        dispatch(setSupplierStakeholdersList(data?.result?.stakeholder_list));
      },
    });
  };
}

export function getAllSupplierStakeholders(parent_id) {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/supplier/get_supplier_users",
      bodyData: { supplier_id: parent_id },
      hideLoader: true,
      hideMsg: true,
      callback: (data) => {
        dispatch(setSupplierStakeholdersList(data?.result?.stakeholder_list));
      },
    });
  };
}
export async function getShareSurveySupplierUserData(bodyData) {
  const data = await apiBolerplate({
    url: "/supplier_user/get_users_with_access_data",
    bodyData,
    hideLoader: true,
    hideMsg: true,
  });

  return data;
}
export async function getShareSurveySupplierUserHasAccess(bodyData) {
  const data = await apiBolerplate({
    url: "/supplier_user/share_survey_access",
    bodyData,
    hideLoader: true,
    hideMsg: true,
  });

  return data;
}

export function createSupplierStakeholder(
  details,
  getSupplierStakeholders,
  isFrom
) {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/stakeholder/create_stakeholder",
      bodyData: { ...details },
      hideLoader: false,
      hideMsg: false,
      messageType: "success",
      callback: (data) => {
        if (isFrom === "supplierAdmin") {
          dispatch(getSupplierAdminStakeholders(details?.supplier_id));
        } else {
          dispatch(getSupplierStakeholders(details?.parent_id));
        }
      },
    });
  };
}

// -------------------- Company Documents --------------------

export function getSupplierSurveyDocuments(supplier_id) {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/survey/get_supplier_survey_documents",
      bodyData: { supplier_id },
      hideLoader: true,
      hideMsg: true,
      callback: (data) => {
        dispatch(setSupplierSurveyDocuments(data?.result));
      },
    });
  };
}
